import { atom } from "recoil";

export type WebImageSelection = {
    url: string;
    mimeType: string;
};

export type WebImageChooserInfo = {
    onSelectImage: (uri?: WebImageSelection | null | undefined) => void | Promise<void>;
};

export const webImageChooser = atom<WebImageChooserInfo | null>({
    key: "webImageChooser",
    default: null,
});
